/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preset_SavedInputs */

const en_video_export_preset_saved = /** @type {(inputs: Video_Export_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset saved successfully`)
};

const fr_video_export_preset_saved = /** @type {(inputs: Video_Export_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prereglage enregistre avec succes`)
};

const de_video_export_preset_saved = /** @type {(inputs: Video_Export_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung erfolgreich gespeichert`)
};

const it_video_export_preset_saved = /** @type {(inputs: Video_Export_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preimpostazione salvata correttamente`)
};

const ru_video_export_preset_saved = /** @type {(inputs: Video_Export_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительные настройки успешно сохранены.`)
};

const es_video_export_preset_saved = /** @type {(inputs: Video_Export_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preajuste guardado exitosamente`)
};

const zh_cn2_video_export_preset_saved = /** @type {(inputs: Video_Export_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设已成功保存`)
};

const ja_video_export_preset_saved = /** @type {(inputs: Video_Export_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが正常に保存されました`)
};

const hi_video_export_preset_saved = /** @type {(inputs: Video_Export_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट सफलतापूर्वक सहेज लिया गया`)
};

const pt_pt2_video_export_preset_saved = /** @type {(inputs: Video_Export_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinição salva com sucesso`)
};

/**
* | output |
* | --- |
* | "Preset saved successfully" |
*
* @param {Video_Export_Preset_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_saved = /** @type {((inputs?: Video_Export_Preset_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preset_saved(inputs)
	if (locale === "de") return de_video_export_preset_saved(inputs)
	if (locale === "it") return it_video_export_preset_saved(inputs)
	if (locale === "ru") return ru_video_export_preset_saved(inputs)
	if (locale === "es") return es_video_export_preset_saved(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preset_saved(inputs)
	if (locale === "ja") return ja_video_export_preset_saved(inputs)
	if (locale === "hi") return hi_video_export_preset_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preset_saved(inputs)
	return en_video_export_preset_saved(inputs)
});